import { minimumRoleAllows, roleCan } from '@/auth/roles';
export function roleRequirementAllows(role, requirement) {
    return Array.isArray(requirement)
        ? roleCan(role, requirement)
        : minimumRoleAllows(role, requirement);
}
export function isOgStaff(role) {
    return roleCan(role, ['support', 'admin', 'editor', 'ad_manager', 'ad_lead']);
}
